import React from "react";
import PropTypes from "prop-types";
import { impersonateUser, logoutUser } from "actions/loginActions";
import { connect } from "react-redux";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";

const PAGES = {
  Dashboard: "/dashboard",
  EmployeeProfile: "/userProfile",
  Enrolment: "/shop/enrolment",
  BenefitsStatement: "/benefits/statement",
  BenefitsDocuments: "/benefits/documents",
  StatementOfAccount: "/claims/accounts",
  PendingClaims: "/claims/pending",
  HistoricalClaims: "/claims/history",
  NewClaims: "/claims/submit",
  MyActivities: "/wellness/activities",
  NeedHelp: "/needhelp",
};

// List of posible page
//
// Parameters - page:
// Return:
//  page - Contain page route.
const redirectTo = page => PAGES[page] || PAGES["Dashboard"];

class ImpersonateUser extends React.Component {
  componentDidMount() {
    // get token from query string
    const { query, isAuthenticated, impersonateUser, push, intl } = this.props;
    const { token, page } = query;

    // if token doesn't exist, redirect user to login page
    if (!token) {
      // document.location.href =  "/";
      if (!isAuthenticated) {
        push("/");
      }

      push(redirectTo(page));
    }

    // if user is authenticated, confirm if user wants to logout and impersonate new user
    if (isAuthenticated) {
      const confirmAction = confirm(
        intl.formatMessage(messages.loggedInImpersonationTextDescription)
      ); //eslint-disable-line no-alert

      if (confirmAction) {
        logoutUser();
        impersonateUser(token, push, redirectTo(page));
      } else {
        push(redirectTo(page));
      }
    } else {
      impersonateUser(token, push, redirectTo(page));
    }
  }

  render() {
    const { intl } = this.props;
    return (
      <p>
        {intl.formatMessage(messages.userImpersonationTextDescription)}
      </p>
    );
  }
}

ImpersonateUser.propTypes = {
  query: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  impersonateUser: PropTypes.func,
  push: PropTypes.func,
  intl: intlShape.isRequired,
};

const mapStateToProps = ({ login: { isAuthenticated } }) => ({
  isAuthenticated,
});

const mapDispatchToProps = {
  impersonateUser,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ImpersonateUser)
);



// WEBPACK FOOTER //
// ./components/login/impersonateUser.jsx